import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Alert, Box } from '@mui/material';

const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  
  const isAdmin = user?.role === 'ADMIN' || user?.user_type === 'admin';
  
  if (!user) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">Please sign in to access this page</Alert>
      </Box>
    );
  }
  
  if (!isAdmin) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">Access denied. Admin privileges required.</Alert>
      </Box>
    );
  }
  
  return children;
};

export default AdminRoute;